import React from 'react';
import { Box, Typography } from '@mui/material';
import { missionVisionTextBlockStyles } from './MissionVisionTextBlock.styles';

const MissionVisionTextBlock = ({ heading, title, body }) => {
  const styles = missionVisionTextBlockStyles;

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.heading}>{heading}</Typography>
      <Typography sx={styles.title}>{title}</Typography>
      <Typography sx={styles.body}>{body}</Typography>
    </Box>
  );
};

export default MissionVisionTextBlock;


